import { render, staticRenderFns } from "./ColorSwatch.vue?vue&type=template&id=5ce0f9ef&scoped=true"
import script from "./ColorSwatch.vue?vue&type=script&lang=js"
export * from "./ColorSwatch.vue?vue&type=script&lang=js"
import style0 from "./ColorSwatch.vue?vue&type=style&index=0&id=5ce0f9ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce0f9ef",
  null
  
)

export default component.exports